module.exports = __webpack_public_path__ + "static/media/codepen.2fed2f6f.svg";